// frontend/src/pages/InventoryOverview.tsx
import { useQuery } from "@tanstack/react-query";
import { ProductApi } from "../lib/api";

export default function InventoryOverview() {
  const { data: products, isLoading } = useQuery({ queryKey: ["products"], queryFn: () => ProductApi.list() });

  if (isLoading) return <p className="text-gray-500">Loading inventory...</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Inventory</h1>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Product</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Type</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">On Hand</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Reserved</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Available</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {products?.map((p: any) => (
              <tr key={p.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{p.name}</td>
                <td className="px-4 py-3">
                  <span className="px-2 py-0.5 rounded-full text-xs bg-gray-100">{p.type}</span>
                </td>
                <td className="px-4 py-3 text-right">0</td>
                <td className="px-4 py-3 text-right text-gray-400">0</td>
                <td className="px-4 py-3 text-right font-medium text-green-600">0</td>
              </tr>
            ))}
            {(!products || products.length === 0) && <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-400">No products found</td></tr>}
          </tbody>
        </table>
        <div className="px-4 py-3 bg-gray-50 text-xs text-gray-500 border-t">
          Real-time stock tracking via stock_quant table — quantity tracking incoming.
        </div>
      </div>
    </div>
  );
}
